import React, { useEffect, useRef } from 'react';
import './WhyusImplementation.css';

const implementationProcesses = [
  {
    icon: '/icons/imple1.webp', // Replace with actual icon path
    description: (
      <>
        At Lattice Labs, <strong>we develop unique elite processes</strong> for each service we provide, ensuring our team's delivery is consistent, efficient, and high quality.
      </>
    ),
  },
  {
    icon: '/build.webp', // Replace with actual icon path
    description: (
      <>
        We continuously build on our existing processes, meaning you will be working with processes that have been <strong>improved over 13 years and more than 300 projects.</strong>
      </>
    ),
  },
  {
    icon: '/icons/imple3.webp', // Replace with actual icon path
    description: (
      <>
        Some of our processes, such as the <strong>Product Design Process</strong>, are considered industry best practices and are now taught in universities in the US and Portugal.
      </>
    ),
  },
];

const WhyusImplementation = () => {
  const cardRefs = useRef([]);
  const previousScrollY = useRef(window.scrollY);
  const yOffsets = useRef(Array(implementationProcesses.length).fill(0));

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      cardRefs.current.forEach((ref, index) => {
        if (!ref) return;

        // Only move the side cards (index 0 and 2), keep center card (index 1) static
        if (index === 1) {
          ref.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffsets.current[index] + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffsets.current[index] = newOffset;

        ref.style.transform = `translate3d(0, ${newOffset}px, 0)`;
      });

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="whyus-implementation-section" id="implementation">
      <div className="container">
        <h5 className="implementation-subtitle">IMPLEMENTING PROCESSES AT EVERY STAGE</h5>
        <div className="implementation-cards" style={{ marginTop: '4rem' }}>
          {implementationProcesses.map((process, index) => (
            <div
              key={index}
              className="implementation-card"
              ref={(el) => (cardRefs.current[index] = el)}
            >
              <div className="implementation-icon">
                <img src={process.icon} alt={`Process ${index + 1}`} />
              </div>
              <p className="implementation-description">{process.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyusImplementation;
